import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Image1, Image8, Image9 } from "../assets";
import { Footer, Navbar2, Impact, DetailsGallery } from "../components";
import {
  Linkedin,
  Instagram,
  Twitter,
  Youtube,
} from "../components/ButtonLinks";
import { getProject } from "../api/index";

function DetailsPage({ match }) {
  const { project } = useParams();
  const [detail, setDetail] = useState({});

  useEffect(() => {
    const fetch = async () => {
      try {
        const { data } = await getProject(project);
        setDetail(data);
      } catch (err) {
        console.log(err);
      }
    };
    fetch();
  }, [project]);

  console.log(detail?.id);

  const photoback = () => {
    switch (detail?.id) {
      case "project-shakti":
        return Image8;
      case "project-avanti":
        return Image9;
      case "project-ecotopia":
        return Image1;
      default:
        return "";
    }
  };

  return (
    <div className="h-full">
      <div
        style={{ backgroundImage: `url(${photoback()})` }}
        className="bg-no-repeat bg-cover z-0 h-3/5"
      >
        <div className="max-w-7xl mx-auto">
          <Navbar2 />
        </div>
      </div>
      <div className="bg-white z-10 m-auto -mt-20 shadow-md w-3/4 mb-20">
        <h1 className="font-semibold text-4xl md:text-5xl lg:text-7xl text-mix-400 text-center pt-8 pb-4 font-josefin">
          {detail?.title}
        </h1>
        <h2 className="font-bold text-base md:text-lg lg:text-lg mb-10 text-center">
          {detail?.heading}
        </h2>
        <h3 className="text-center px-16">{detail?.subTitle}</h3>
        <div className="flex justify-center items-center w-4/5 space-x-8 py-8 mx-auto">
          <Linkedin size={30} />
          <Instagram size={30} />
          <Youtube size={30} />
          <Twitter size={30} />
        </div>
      </div>

      <section className="w-3/4 m-auto">
        <span className="my-5">
          <div className="font-bold text-base md:text-lg lg:text-lg">
            {detail?.quote}
          </div>
          <br />
          {detail?.mainContent1}
          <Impact purpleText />
          {detail?.mainContent2}
        </span>
        <span>
          <DetailsGallery projectId={detail?.id} />
        </span>
        <div className="text-center mb-20">
          <h2 className="font-bold font-montserrat text-xl mb-10">
            <span className="text-mix-400 text-lg md:text-xl lg:text-2xl">
              {detail?.title}
            </span>{" "}
            is open for collaborations.
          </h2>
          <p className="font-montserrat text-base md:text-lg lg:text-lg">
            Reach out to us at{" "}
            <a href="mailto:drishtibpit@gmail.com" className="font-bold reach">
              drishtibpit@gmail.com
              <span></span>
            </a>{" "}
            to know more.
          </p>
        </div>
      </section>
      <section className="w-3/4 m-auto"></section>
      <Footer support />
    </div>
  );
}

export default DetailsPage;
